/**
 * 契約情報ページ用のスクリプト
 */
 if (is_route('termination.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        termination_event_set();
        termination_setting_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
 window.termination_event_set = function() {

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id'], true);
    });
    
    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal');
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });

}

/**
 * 解約設定モーダルのイベント設定
 */
window.termination_setting_event_set = function() {

    /*---- ステップボタンクリック時（新規登録時） ----*/

    // 前へ
    $(document).on('click', '[data-prev-step]', function () {
        // Partセレクターの指定
        let currentPartSubmit = $(this).parents('.modal-footer');
        let prevPart = $(this).data('prev-step');
        let prevPartTrigger = create_id(prevPart + '-trigger');
        let prevPartSubmit = create_id(prevPart + '-submit');
        $(currentPartSubmit).addClass('display-none');
        $(prevPartSubmit).removeClass('display-none');
        bs_step_trigger(prevPartTrigger);
    });

    // 次へ
    $(document).on('click', '[data-next-step]', function () {
        // Partセレクターの指定
        let currentPartSubmit = $(this).parents('.modal-footer');
        let nextPart = $(this).data('next-step');
        let nextPartTrigger = create_id(nextPart + '-trigger');
        let nextPartSubmit = create_id(nextPart + '-submit');
        // ModalとPartセレクターの指定
        let modalId = '#termination-setting-modal';
        let formId = '#termination-setting-modal-form';
        let action = $(formId).data('confirm-action');
        // 確認対象のパートをパラメータにセット
        $('#termination-setting-modal-confirm_step').val($(this).data('confirm-step'));
        // 送信前にエラーをリセット
        _error.reset()
        termination_set_steper_error(false);
        // 確認用のpost送信
        _ajax.confirm_submit(formId, action, function (results) {
            $(currentPartSubmit).addClass('display-none');
            $(nextPartSubmit).removeClass('display-none');
            bs_step_trigger(nextPartTrigger);
        }, function(xhr, status, errorThrown){
            // エラーをセットする
            _error.set(modalId, xhr, status, errorThrown, false);
            // ステップエラーを表示
            termination_set_steper_error();
        });
    });

    /*---- グループ会社選択時 ----*/

    $(document).on('change', '#termination-setting-modal-holding_id', function() {
        if($(this).val() != null && $(this).val().length > 0){
            updateTerminationPlanForms($(this));
        }
    });

    function updateTerminationPlanForms(elm)
    {
        let action = $('#plan_forms').data('action');
        // 送信
        _ajax.post(action, [
            {'name': 'id', 'value': $('#termination-setting-modal-id').val()},
            {'name': 'holding_id', 'value': $(elm).val()},
        ], function (results) {
            $('#plan_forms').html(results);
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        }, 'html');
    }

    /*---- 解約プラン選択時 ----*/

    // $(document).on('change', '#termination-setting-modal-count', function() {
    $(document).on('click', '#plan-part-submit', function () {
        let termination_plan_types = [];
        let plan_type_lists = document.getElementsByName("plan_type[]");
        let count_lists = document.getElementsByName("count[]");
        for (var i = 0; i < plan_type_lists.length; i++) {
            termination_plan_types.push({plan_type: plan_type_lists[i].value, count: count_lists[i].value});
        }
        json_termination_plan_types = JSON.stringify(termination_plan_types);
        updateTerminationAccountForms(json_termination_plan_types);
        updateTerminationTerminalForms(json_termination_plan_types);
    });

    function updateTerminationAccountForms(json_termination_plan_types)
    {
        let action = $('#account_forms').data('action');

        // 送信
        _ajax.post(action, [
            {'name': 'id', 'value': $('#termination-setting-modal-id').val()},
            {'name': 'holding_id', 'value': $('#termination-setting-modal-holding_id').val()},
            {'name': 'termination_plan_types', 'value': json_termination_plan_types},
        ], function (results) {
            $('#account_forms').html(results);
            initialize_select2();
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        }, 'html');
    }

    function updateTerminationTerminalForms(termination_plan_types)
    {
        let action = $('#terminal_forms').data('action');
        // 送信
        _ajax.post(action, [
            {'name': 'id', 'value': $('#termination-setting-modal-id').val()},
            {'name': 'holding_id', 'value': $('#termination-setting-modal-holding_id').val()},
            {'name': 'termination_plan_types', 'value': termination_plan_types},
        ], function (results) {
            $('#terminal_forms').html(results);
            initialize_select2();
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        }, 'html');
    }
}
// ステッパーへのエラー表示処理
window.termination_set_steper_error = function (showError = true) {
    if (showError) {
        $('#base-part-trigger').toggleClass('error', ($('#base-part').find('.invalid-feedback:not(.copy)').length > 0));
        $('#plan-part-trigger').toggleClass('error', ($('#plan-part').find('.invalid-feedback:not(.copy)').length > 0));
        $('#account-part-trigger').toggleClass('error', ($('#account-part').find('.invalid-feedback:not(.copy)').length > 0));
        $('#terminal-part-trigger').toggleClass('error', ($('#terminal-part').find('.invalid-feedback:not(.copy)').length > 0));
    } else {
        $('#base-part-trigger').removeClass('error');
        $('#plan-part-trigger').removeClass('error');
        $('#account-part-trigger').removeClass('error');
        $('#terminal-part-trigger').removeClass('error');
    }
}